const gregorian_german = {
  name: 'gregorian_german',
  months: [
    ['Januar', 'Jan'],
    ['Februar', 'Feb'],
    ['März', 'Mär'],
    ['April', 'Apr'],
    ['Mai', 'Mai'],
    ['Juni', 'Jun'],
    ['Juli', 'Jul'],
    ['August', 'Aug'],
    ['September', 'Sep'],
    ['Oktober', 'Okt'],
    ['November', 'Nov'],
    ['Dezember', 'Dez']
  ],
  weekDays: [
    ['Samstag', 'Sam'],
    ['Sonntag', 'Son'],
    ['Montag', 'Mon'],
    ['Dienstag', 'Die'],
    ['Mittwoch', 'Mit'],
    ['Donnerstag', 'Don'],
    ['Freitag', 'Fre']
  ],
  digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  meridiems: [
    ['AM', 'am'],
    ['PM', 'pm']
  ]
}

export default gregorian_german
